module.exports = __webpack_public_path__ + "assets/img/sdwan-module3-1.8cb4fe33.png";